export default {"src":"/_next/static/media/reddit.129cba04.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};